import React from 'react'
import AdminLayout from '../../layouts/AdminLayout'
import PasswordUpdate from '../../components/PasswordUpdate'

const AdminPassword = () => {
  return (
    <AdminLayout>
    <PasswordUpdate />
    </AdminLayout>
  )
}

export default AdminPassword
